import moment from 'moment';
import pluralize from 'pluralize';
import React from 'react';
import { requestPost } from '../../../../modules/request';

import { ACCOUNT_TYPE_TO_SUBSCRIPTION_TYPES } from './constants';

import { Tooltip, helpIcon, } from '../../../Shared/index';

export default class SubscriptionHistory extends React.Component {

  content() {
    const subscriptionHistoryRows = this.subscriptionHistoryRows();
    if (subscriptionHistoryRows.length > 0) {
      return (
        <table>
          <tbody>
            <tr>
              {this.tableHeaders()}
            </tr>
            {subscriptionHistoryRows}
          </tbody>
        </table>
      );
    }
    return (
      <div className="empty-state flex-row justify-content">
        <h3>You have not yet started a Quill Premium Subscription</h3>
        <p><a href="/premium">Purchase Quill Premium</a> or apply credits to get access to Premium reports.</p>
      </div>
    );
  }

  paymentContent(subscription) {
    const { authorityLevel, } = this.props
    if (authorityLevel) {
      if (subscription.payment_amount) {
        return `$${subscription.payment_amount / 100}`;
      } else if (subscription.payment_method === 'Premium Credit') {
        return subscription.payment_method;
      }
    }
    return '--';
  }

  subscriptionHistoryRows() {
    const { subscriptions, premiumCredits, view, } = this.props

    const rows = [];
    subscriptions.forEach((sub) => {
      const startD = moment(sub.start_date);
      const endD = moment(sub.expiration);
      const calculatedDuration = endD.diff(startD, 'months');
      // if duration is calculated as 0, make it 1
      const duration = Math.max(calculatedDuration, 1);
      const matchingTransaction = premiumCredits.find(transaction => (transaction.source_id === sub.id && transaction.source_type === 'Subscription' && transaction.amount > 0));
      if (matchingTransaction) {
        const amountCredited = matchingTransaction.amount > 6
          ? Math.round(matchingTransaction.amount / 7)
          : 1;
        rows.push(
          <tr className="subscription-row text-center" key={`${matchingTransaction.id}-credit-subscription-table`}>
            <td colSpan="5">
              Your school purchased School Premium during your subscription, so we credited your account with {`${amountCredited} ${pluralize('week', amountCredited)}`} of Teacher Premium.
            </td>
          </tr>
        );
      }
      const subscriptionTypeContent = (
        <span>
          {ACCOUNT_TYPE_TO_SUBSCRIPTION_TYPES[sub.account_type]}
          <Tooltip
            tooltipText={`${sub.account_type} subscription`}
            tooltipTriggerText={<img alt={helpIcon.alt} className="subscription-tooltip" src={helpIcon.src} />}
          />
        </span>
      )

      const tds = [
        <td key={`${sub.id}-1-row`}>{moment(sub.created_at).format('MMMM Do, YYYY')}</td>,
        <td key={`${sub.id}-2-row`}>{subscriptionTypeContent}</td>,
        <td key={`${sub.id}-3-row`}>{this.paymentContent(sub)}</td>,
        <td key={`${sub.id}-4-row`}>{`${duration} ${pluralize('month', duration)}`}</td>,
        <td key={`${sub.id}-5-row`}>{`${startD.format('MM/DD/YY')} - ${endD.format('MM/DD/YY')}`}</td>
      ]

      if (view === 'subscriptionHistory') {
        const href = `${window.postbuildEnv.DEFAULT_URL}/cms/subscriptions/${sub.id}/edit`
        const key = `${sub.id}-6-row`

        if (sub.stripe_invoice_id) {
          tds.push(<td key={key}><a href={href} rel='noopener noreferrer' target='_blank'>View in Stripe</a></td>)

          if (sub.recurring && sub.stripe_subscription_id && sub.de_activated_date === null && !this.isExpired(sub)) {
            const href = `${window.postbuildEnv.DEFAULT_URL}/stripe_integration/subscription_renewals`
            const params = { cancel_at_period_end: true, stripe_subscription_id: sub.stripe_subscription_id }
            const onSuccess = () => { window.location.reload(); alert('Auto-renewal has been turned off.') }
            const onFailure = () => { alert('Something went wrong. Please contact engineering.') }

            tds.push(
              <td key={`${sub.id}-7-row`}>
                <button
                  className="quill-button-archived secondary outlined small-button"
                  onClick={() => requestPost(href, params, onSuccess, onFailure)}
                >
                  Turn off auto-renewal
                </button>
              </td>
            )
          }
        } else {
          tds.push(<td key={key}><a href={href}>Edit Subscription</a></td>)
        }
      }
      rows.push(<tr key={`${sub.id}-subscription-table`}>{tds}</tr>)
    })
    return rows;
  }

  isExpired(subscription) {
    const expiration = moment(subscription.expiration);
    const now = moment();
    return expiration.isBefore(now);
  }

  tableHeaders() {
    const { view, } = this.props

    const tableHeaders = ['Purchase Date', 'Subscription', 'Payment', 'Length', 'Start & End Date'];
    if (view === 'subscriptionHistory') {
      tableHeaders.push('Link');
    }

    return tableHeaders.map((content, i) => <th key={`${i}-table-header`}>{content}</th>);
  }

  render() {
    return (
      <section aria-labelledby="premiumSubscriptionHistoryTitle" className="subscription-history">
        <h2 id="premiumSubscriptionHistoryTitle">Premium Subscription History</h2>
        <div className="table-container">
          {this.content()}
        </div>
      </section>
    );
  }
}

// TODO: refactor SubscriptionHistory into a functional component so this defaultProps can be inlined as a destructured default. defaultProps on class components still works in React 19 but is slated for removal.
SubscriptionHistory.defaultProps = {
  premiumCredits: []
}
